import React from "react";
import logo from "../Images/logo.png";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "../Css/All.css";

const List = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <>
      <p>
        <header>
          <div className="container container-flex">
            <div className="logoContainerHeader">
              <NavLink to="/">
                <img src={logo} alt="logo" className="headerLogo" />
              </NavLink>
            </div>
            <nav>
              <div className="list">
                <NavLink
                  to="/"
                  className={(navdata) =>
                    navdata.isActive ? "activeItem" : "inactiveItem"
                  }
                >
                  Home
                </NavLink>
                <NavLink
                  to="/about"
                  className={(navdata) =>
                    navdata.isActive ? "activeItem" : "inactiveItem"
                  }
                >
                  About
                </NavLink>
                <NavLink
                  to="/services"
                  className={(navdata) =>
                    navdata.isActive ? "activeItem" : "inactiveItem"
                  }
                >
                  Services
                </NavLink>
                <NavLink
                  to="/pricing"
                  className={(navdata) =>
                    navdata.isActive ? "activeItem" : "inactiveItem"
                  }
                >
                  Pricing
                </NavLink>
                <NavLink
                  to="/contact"
                  className={(navdata) =>
                    navdata.isActive ? "activeItem" : "inactiveItem"
                  }
                >
                  Contact
                </NavLink>
              </div>
            </nav>
            <div className="navAuthButtons">
              {currentUser ? (
                <>
                  <NavLink
                    to="/dashboard"
                    className={(navdata) =>
                      navdata.isActive ? "activeItem" : "inactiveItem"
                    }
                  >
                    Dashboard
                  </NavLink>
                  <button className="btn navLogoutBtn" onClick={handleLogout}>
                    <span className="readMore">Logout</span>
                  </button>
                </>
              ) : (
                <>
                  <NavLink to="/login" className="inactiveItem">
                    Login
                  </NavLink>
                  <NavLink to="/signup" className="btn">
                    <span className="readMore">Get Started</span>
                  </NavLink>
                </>
              )}
            </div>
          </div>
        </header>
      </p>
    </>
  );
};

export default List;
